import { HttpBackend, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { tap } from 'rxjs';
import { LanguageService } from '@services/language';

export let APP_CONFIG: AppConfig;

// Match the src/assets/config/config.json file
export class AppConfig {
    public readonly version: string;
    public readonly apiBaseUrl: string;

    public constructor(version: string, apiBaseUrl: string) {
        this.version = version;
        this.apiBaseUrl = apiBaseUrl;
    }
}

export const initializeTranslateService = (languageService: LanguageService) => {
    return () => languageService.init();
};

export const createTranslateLoader = (httpBackend: HttpBackend) => {
    const httpClient = new HttpClient(httpBackend);
    return new TranslateHttpLoader(httpClient, 'assets/i18n/', '.json');
};

export const loadConfig = (httpBackend: HttpBackend) => {
    const httpClient = new HttpClient(httpBackend);
    return () =>
        httpClient.get('/assets/config/config.json').pipe(
            tap((data) => {
                const typedData = data as { version: string; apiBaseUrl: string };
                APP_CONFIG = new AppConfig(typedData.version, typedData.apiBaseUrl);
            })
        );
};
